module.exports = __webpack_public_path__ + "media/escudos/logo_MINEDU-fdc4f331.png";